import React, { useState, useEffect } from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import DebounceTextInput from 'components/DebounseTextInput';
import AdvancedFilters from 'components/AdvancedFilters';
import OrderFilter from 'pages/Orders/components/OrderFilter';
import { ORDER_STATUS } from 'utils/constants';
import { Label } from 'reactstrap';
import Select from 'react-select';
import OrderedTable from './component/OrderedTable';
import './OrderControls.css';

const initialValues = {
  buyer: null,
  grades: null,
  seller: null,
  status: null,
  cityName: '',
};

const ORDER_STATUS_FILTER_OPTIONS = [
  { label: 'All Status', value: '' },
  ...ORDER_STATUS,
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'Deleted', value: 'DELETED' },
];

const CommonOrderComponent = ({
  defaultValue,
  type = 'offer',
  key = '',
  activeView = 'kanban',
  headerControls = null,
}) => {
  const [showAdvancedSearchBar, setShowAdvancedSearchBar] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [filterValue, setFilterValue] = useState([]);
  const [orderStatusFilter, setOrderStatusFilter] = useState('');

  useEffect(() => {
    if (activeView !== 'listing') {
      setOrderStatusFilter('');
    }
  }, [activeView]);

  const toggleAdvancedSearchBar = () => {
    setShowAdvancedSearchBar(!showAdvancedSearchBar);
  };
  const handleChange = (value) => {
    setSearchString(value);
  };
  const handleFilters = (val) => {
    setFilterValue([
      {
        key: 'entityName',
        joinAttributeName: 'buyer',
        value: val?.buyer?.entityName || '',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'name',
        value: val?.grade?.name || '',
        joinAttributeName: 'grade',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'entityName',
        joinAttributeName: 'seller',
        value: val?.seller?.entityName || '',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'cityName',
        joinAttributeName: type,
        innerAttributeName: 'city',
        value: val?.cityName || '',
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
    ]);
  };

  const handleResetFilter = () => {
    setFilterValue([]);
    toggleAdvancedSearchBar();
  };

  return (
    <div key={key} className="order-page">
      <ErrorBoundary>
        <div className="order-filter-toolbar">
          {headerControls}
          <AdvancedFilters
            PositionLeft="0"
            PositionTop="0"
            handleFilters={handleFilters}
            initialValues={initialValues}
            toggleAdvancedSearchBar={toggleAdvancedSearchBar}
            id="order"
          >
            <OrderFilter />
          </AdvancedFilters>
          {activeView === 'listing' && (
            <div className="filter-row-ui">
              <div className="form-group mb-0">
                <Label>Status</Label>
                <Select
                  name="Status"
                  options={ORDER_STATUS_FILTER_OPTIONS}
                  value={ORDER_STATUS_FILTER_OPTIONS.find(
                    (opt) => opt.value === orderStatusFilter,
                  )}
                  onChange={(selectedOption) =>
                    setOrderStatusFilter(
                      selectedOption ? selectedOption.value : '',
                    )
                  }
                  classNamePrefix="react-select"
                  placeholder="Status"
                />
              </div>
            </div>
          )}
        </div>

        <DebounceTextInput
          onInputChange={handleChange}
          delay={500} // Set your desired delay in milliseconds
          value={searchString}
          placeholder="Search Orders"
          classWrapper="right-search"
          positionTop="-40px"
        />

        <OrderedTable
          searchString={searchString}
          filterValue={filterValue}
          defaultValue={defaultValue}
          showAdvancedSearchBar={showAdvancedSearchBar}
          handleResetFilter={handleResetFilter}
          activeView={activeView}
          orderStatusFilter={orderStatusFilter}
        />
      </ErrorBoundary>
    </div>
  );
};

export default CommonOrderComponent;
